import { render } from "./TopLoading.vue?vue&type=template&id=dd80f242&scoped=true"
import script from "./TopLoading.vue?vue&type=script&lang=js"
export * from "./TopLoading.vue?vue&type=script&lang=js"

import "./TopLoading.vue?vue&type=style&index=0&id=dd80f242&scoped=true&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd80f242"]])

export default __exports__